// src/components/layouts/AuthLayout.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useProjects } from '../../contexts/ProjectContext';
import { hasCompletedPaymentOrBypass } from '../../utils/paymentGate';

const AuthLayout = () => {
  const { user, loading: authLoading, onboardingCompleted } = useAuth();
  const { isCurrentProjectOnboarded, loading: projectLoading } = useProjects();

  // Show loading state if auth or projects are loading
  if (authLoading || projectLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#1ba6ff] border-t-transparent"></div>
          <div className="mt-4 text-gray-700 text-lg font-medium">Loading...</div>
        </div>
      </div>
    );
  }

  // Redirect if user is already logged in
  if (user) {
    if (!hasCompletedPaymentOrBypass()) {
      return <Navigate to="/checkout" replace />;
    }
    
    // Check if onboarding is completed (either from AuthContext or localStorage)
    const cachedOnboardingCompleted = localStorage.getItem(`onboarding_${user.uid}`) === 'completed';
    const isOnboardingComplete = onboardingCompleted || cachedOnboardingCompleted;
    
    // If payment is completed, check onboarding status
    if (isOnboardingComplete || isCurrentProjectOnboarded === true) {
      return <Navigate to="/dashboard/content-planner" replace />;
    }
    
    return <Navigate to="/onboarding/business" replace />;
  }

  return <Outlet />;
};

export default AuthLayout;